import { Loading } from '@shape-ds/components';
import { IS_DEMO } from 'config/constants';
import { HOME_PAGE, LOGIN_PAGE } from 'config/paths';
import { useAuthentication } from 'hooks';
import { Navigate, RouteProps, useLocation } from 'react-router-dom';

type PrivateRouteProps = RouteProps & {
  children: JSX.Element;
};

export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuthentication();

  if (IS_DEMO) return children;

  if (isLoading) return <Loading center dataTestId="loading" />;

  const isLoginPage = location.pathname === LOGIN_PAGE;
  const shouldRedirect = !isAuthenticated && !isLoginPage;

  if (shouldRedirect) {
    const fallbackPath = isLoginPage ? HOME_PAGE : location.pathname;
    const locationFrom = location.state?.from ?? fallbackPath;
    return <Navigate to={LOGIN_PAGE} state={{ from: locationFrom }} />;
  }

  return children;
};
